var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-header'),_c('div',{staticClass:"py-36 h-screen"},[_c('h1',[_vm._v("hi video")]),_c('video-player',{attrs:{"options":_vm.videoOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }